/**
 * Labstep
 *
 * @module components/ResourceItem/Action/Duplicate
 * @desc Button to add resource from resource list
 */

import { EntityActionDuplicate } from 'labstep-web/components/Entity/Action/Duplicate';
import { Resource } from 'labstep-web/models/resource.model';
import type React from 'react';
import type { IResourceItemActionDuplicateProps } from './types';

export const ResourceItemActionDuplicate: React.FC<
  IResourceItemActionDuplicateProps
> = ({ resourceItem, noRedirect }) => (
  <EntityActionDuplicate
    entity={resourceItem}
    body={
      {
        resource_id: resourceItem.resource.id,
      } as any
    }
    noRedirect={noRedirect}
    parentName={Resource.entityName}
    parentId={resourceItem.resource.id}
  />
);
